function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { HOUSEHOLD_STATE_NAME } from '../household.constants';
import i18n from 'invision-core/src/components/i18n/i18n';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import CustomerCareLocaleKeys from '../../../../locales/keys';
import { CurrentSharedEntitlementBalancesSelector, IsFetchingSubscriberSummarySelector } from '../../../../reducers/selectors/customer.convergent.biller.selectors';
import { CurrentHouseholdSelector, CurrentHouseholdMemberSelector, HeadOfHouseholdSelector, HouseholdChildMembersSelector, HousholdMembersSorted } from '../../../../reducers/selectors/customer.household.selectors';
import { NA } from '../../../../reducers/constants/billing.payments.constants';
import { retrieveSharedEntitlements } from '../../../../reducers/actions/shared.entitlements.actions';
var OverviewController = /*#__PURE__*/function () {
  function OverviewController($ngRedux, $state) {
    _classCallCheck(this, OverviewController);
    this.$ngRedux = $ngRedux;
    this.$state = $state;
    this.NA = NA;
  }
  return _createClass(OverviewController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          childMembers: HouseholdChildMembersSelector(store),
          currentHouseholdMembers: HousholdMembersSorted(store),
          currentMember: CurrentHouseholdMemberSelector(store),
          headOfHousehold: HeadOfHouseholdSelector(store),
          household: CurrentHouseholdSelector(store),
          isFetchingSubscriberSummary: IsFetchingSubscriberSummarySelector(store),
          isDbss: IsDbss(store),
          sharedEntitlementBalances: CurrentSharedEntitlementBalancesSelector(store),
          unitsOfMeasure: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.UnitsOfMeasure, store),
          unitsOfMeasureLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.UnitsOfMeasure, store)
        };
      };
      var controllerActions = {
        fetchUnitOfMeasureTypes: MetadataActions.codes.fetchUnitOfMeasureTypes,
        retrieveSharedEntitlements: retrieveSharedEntitlements
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.customerCareKeys = CustomerCareLocaleKeys;
      this.stateOrName = HOUSEHOLD_STATE_NAME;
      if (!this.state.sharedEntitlementBalances && this.state.headOfHousehold && this.state.isDbss) {
        this.actions.retrieveSharedEntitlements(this.state.headOfHousehold.SubscriberId);
      }
      if (!this.state.unitsOfMeasureLoaded) {
        this.actions.fetchUnitOfMeasureTypes();
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "isHeadOfHousehold",
    value: function isHeadOfHousehold(subscriberId) {
      return this.state.headOfHousehold.SubscriberId === subscriberId;
    }
  }, {
    key: "getMemberPrivilegesInfo",
    value: function getMemberPrivilegesInfo(member) {
      return member.Privileges.MemberManagementEnabled ? "".concat(i18n.translate(this.customerCareKeys.HOUSEHOLD.MEMBER), " (").concat(i18n.translate(this.customerCareKeys.HOUSEHOLD.FULL_ACCESS_PRIVILEGES), ")") : member.Privileges.ManageServicesEnabled ? "".concat(i18n.translate(this.customerCareKeys.HOUSEHOLD.MEMBER), " (").concat(i18n.translate(this.customerCareKeys.HOUSEHOLD.SERVICE_LEVEL_PRIVILEGES), ")") : i18n.translate(this.customerCareKeys.HOUSEHOLD.MEMBER);
    }
  }, {
    key: "formatTotal",
    value: function formatTotal(initial, measure) {
      return i18n.translate(this.customerCareKeys.USAGE_DETAILS.TOTAL, {
        initialBalance: initial,
        unitOfMeasure: measure
      });
    }
  }, {
    key: "formatRemaining",
    value: function formatRemaining(remaining, measure) {
      return i18n.translate(this.customerCareKeys.USAGE_DETAILS.REMAINING, {
        BalanceRemaining: remaining,
        unitOfMeasure: measure
      });
    }
  }, {
    key: "determineConsumedValue",
    value: function determineConsumedValue(data) {
      if (data.InitialBalance && data.BalanceRemaining) {
        return Math.max(data.InitialBalance - data.BalanceRemaining, 0).toFixed(2);
      } else {
        return data.BalanceConsumed;
      }
    }
  }]);
}();
export default {
  template: require('./overview.html'),
  controllerAs: 'Overview',
  controller: OverviewController
};